<template>
  <div class="bookmarks">
    <div
      v-for="bookmark in bookmarks"
      :key="bookmark.id"
      class="bookmarks__single"
    >
      <div
        :style="
          `background-image: url(${$getCourseBackground(
            bookmark.course,
            'small'
          )})`
        "
        class="bookmarks__course-info"
      >
        <div class="bookmarks__icon-container">
          <img
            class="bookmarks__course-icon"
            src="@/assets/icons/course/course_icon.png"
          />
          <button
            @click="deleteBookmark(bookmark.id)"
            class="bookmarks__delete"
          >
            <i class="material-icons bookmarks__delete-icon">delete</i>
          </button>
        </div>
        <p class="bookmarks__course-title">{{ bookmark.course.title }}</p>
      </div>
      <div class="bookmarks__details">
        <p class="bookmarks__video-title">{{ bookmark.video_title }}</p>
        <p class="bookmarks__video-time">
          <span class="material-icons bookmarks__clock-icon">alarm</span>
          {{ $duration.durationFromSecs(bookmark.time) }}
        </p>
        <div class="bookmarks__note">
          <p class="lead">note:</p>
          <p class="data">{{ bookmark.title }}</p>
        </div>
        <div class="bookmarks__resume-wrapper">
          <button @click="openBookmark(bookmark)" class="btn__action">
            Resume
            <i class="btn__action-icon material-icons">play_circle_filled</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDashboardBookmarks',
  props: {
    bookmarks: {
      type: Array,
      required: true,
    },
  },
  methods: {
    async openBookmark(bookmark) {
      this.$store.dispatch('content/setPlayingVideoId', bookmark.video_id)
      this.$store.dispatch('content/setPlayingVideoTime', bookmark.time)
      this.$router.push({
        name: 'course',
        params: {
          slug: bookmark.course_slug,
          id: bookmark.course_id,
        },
      })
    },
    deleteBookmark(id) {
      this.$emit('deleteBookmarkById', id)
    },
  },
}
</script>

<style lang="scss" scoped>
.bookmarks {
  @include mobile {
    display: flex;
    flex-wrap: wrap;
  }
  &__single {
    padding-right: 10px;
    width: 320px;
    display: flex;
    flex-direction: column;
  }
  &__delete {
    background-color: transparent;
    border: none;
    line-height: 1;
    margin: 0 0 0 10px;
  }
  &__delete-icon {
    color: #fff;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
    &:hover {
      color: var(--red);
    }
  }
  &__course-info {
    padding: 20px;
    height: 200px;
    flex-shrink: 0;
  }
  &__icon-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 20px;
  }
  &__course-icon {
    height: 20px;
  }
  &__course-title {
    color: var(--white);
    font-size: 1.2rem;
    margin: 0;
    width: 210px;
  }
  &__details {
    background-color: var(--light-gray);
    height: 100%;
    min-height: 250px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
  &__video-title {
    color: var(--gray);
    font-size: 1rem;
  }
  &__video-time {
    color: var(--white);
  }
  &__clock-icon {
    font-size: 1.5rem;
  }
  &__note {
    margin-bottom: 20px;
    word-wrap: break-word;
  }
  &__resume-wrapper {
    text-align: center;
    margin: auto 0 0 auto;
  }
}
</style>
